import React, { useState, useEffect } from "react";
import Table from "../../../Common/Table";
import KeyValTable from "../Common/KeyValTable";

const MetaData = ({ data = {} }) => {
  function getItems() {
    return data.metadata || [];
  }
  return (
    <div>
      <h2>MetaData</h2>
      <KeyValTable data={getItems()} />
    </div>
  );
};

export default MetaData;
